import { useEffect, useState } from "react";
import { AlertTriangle, ArrowRight, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";

import { api } from "@/lib/api";

const groupMeta = [
  { key: "expired", label: "Vencidas", tone: "critical" },
  { key: "due_today", label: "Vencen hoy", tone: "today" },
  { key: "upcoming", label: "Próximas 7 días", tone: "upcoming" },
];

export default function ReservationAlertsPanel() {
  const [alerts, setAlerts] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get("/reservations/alerts")
      .then((response) => setAlerts(response.data))
      .catch(() => setError(true));
  }, []);

  if (error) {
    return null;
  }

  if (!alerts) {
    return (
      <section
        className="reservation-alerts-panel loading"
        data-testid="reservation-alerts-loading"
      />
    );
  }

  return (
    <section className="reservation-alerts-panel" data-testid="reservation-alerts-panel">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">SEGUIMIENTO COMERCIAL</span>
          <h2>Vencimientos de reservas</h2>
        </div>
        {alerts.total_urgent ? <AlertTriangle size={21} /> : <CalendarDays size={21} />}
      </div>
      {alerts.total_urgent ? (
        <div className="reservation-alert-groups">
          {groupMeta.map((group) => (
            alerts[group.key].length > 0 && (
              <div className={`reservation-alert-group ${group.tone}`} key={group.key}>
                <strong>{group.label}</strong>
                {alerts[group.key].map((reservation) => (
                  <div
                    data-testid={`reservation-alert-${reservation.id}`}
                    key={reservation.id}
                  >
                    <span>
                      <b>{reservation.lot.manzano} · {reservation.lot.lote}</b>
                      <small>{reservation.client_name}</small>
                    </span>
                    <span>{reservation.days_left < 0
                      ? `${Math.abs(reservation.days_left)} d vencida`
                      : reservation.days_left === 0
                        ? "Vence hoy"
                        : `${reservation.days_left} d`}</span>
                  </div>
                ))}
              </div>
            )
          ))}
        </div>
      ) : (
        <p className="reservation-alert-clear" data-testid="reservation-alerts-clear">
          No hay reservas que vencerán en los próximos 7 días.
        </p>
      )}
      <Link
        className="reservation-alert-link"
        data-testid="reservation-alerts-reports-link"
        to="/reportes"
      >
        Ver reservas activas <ArrowRight size={16} />
      </Link>
    </section>
  );
}